<template>
    <section class="container">

        <header class="container__header">

            <h1>Opret bestilling</h1>

        </header>

        <section class="container__body container__body--xlg">

            <section class="row choose--order">

                <article class="choose__wrap">

                    <router-link :to="{name:'make-order'}" class="item">

                        <i class="icon--sm fas fa-book"></i>

                        <h1>Produkt</h1>
                        <p>Opret en ordre og vælg <br> udfra et eksisterende produkt.</p>

                    </router-link>

                    <router-link :to="{name:'make-productless-order.product'}" class="item">

                        <i class="icon--sm fas fa-book"></i>

                        <h1>Valgfri</h1>
                        <p>Opret en ordre og vælg <br> uden begrænsninger.</p>

                    </router-link>

                </article>

            </section>

        </section>

    </section>
</template>

<script>
export default {
    name: "orderToMakeChoice"
}
</script>

<style scoped>

</style>
